
export const isLoggedIn = () => {
    let data = localStorage.getItem('tokenAdmin');
    if (data != null) return true;
    else return false;
}

export const doLogin = (token, fullName, email, id) => {
    const resolvedToken =
        typeof token === "string"
            ? token
            : token?.accessToken ??
              token?.token ??
              token?.data?.accessToken ??
              token?.data?.token ??
              token?.data?.data?.accessToken ??
              token?.data?.data?.token;

    if (!resolvedToken) {
        throw new Error("Admin login returned no accessToken");
    }

    localStorage.setItem("tokenAdmin", resolvedToken);
    localStorage.setItem("fullNameAdmin", fullName || "");
    localStorage.setItem("emailAdmin", email || "");
    localStorage.setItem("user", id || "");

    window.location.replace("/manage-categories");
};

export const doLogout = (next) => {
    localStorage.removeItem('fullNameAdmin');
    localStorage.removeItem('emailAdmin');
    localStorage.removeItem('tokenAdmin')
    //next()
}
